import { createSelectors } from "@/redux/helpers/selector";
import { PRODUCT_TYPE_PRODUCT_KIT_LABEL } from "@/utils/constants";

import { MODULE } from "./constants";

// Simple selectors via helpers
export const [
  getErrors,
  getDrawingsList,
  productsFromSalesOrder,
  drawingsFromSalesOrder,
  isFetchingStatus,
  getSelectedProductUids,
  getSelectedDrawingUids,
] = createSelectors(MODULE, [
  "errors",
  "drawingsList",
  "products",
  "drawingItems",
  "isFetchingStatus",
  "selectedProductUids",
  "selectedDrawingUids",
]);

// Derived selectors
export const hasSelectedProduct = (state) => {
  const uids = getSelectedProductUids(state);
  return uids.length > 0;
};

export const areAllSelectableProductAndDrawingSelected = (state) => {
  const products = productsFromSalesOrder(state);
  const drawings = drawingsFromSalesOrder(state);
  const productsAndDrawings = [...drawings, ...products];

  return (
    productsAndDrawings.length ===
    getSelectedProductUids(state).length + getSelectedDrawingUids(state).length
  );
};

export const getTotalLength = (state) => {
  const products = productsFromSalesOrder(state);
  const drawings = drawingsFromSalesOrder(state);
  return products.length + drawings.length;
};

export const getSelectedLength = (state) =>
  getSelectedProductUids(state).length + getSelectedDrawingUids(state).length;

export const groupedProducts = (state) => {
  const items = productsFromSalesOrder(state);
  const kitItems = items.filter((item) => item.isKitItem);
  const subKitParents = items.filter((item) => item.isSubKitParent);
  const subKitItems = items.filter((item) => item.isSubKitItem);

  const productKits = items.filter((item) => {
    if (!item.productType) {
      return false;
    }

    const hasKitItems = kitItems.some((kitItem) => kitItem.parentItem === item.uid);
    const hasSubKits = subKitParents.some((subKit) => subKit.parentItem === item.uid);

    return hasKitItems || hasSubKits || item.productType === PRODUCT_TYPE_PRODUCT_KIT_LABEL;
  });

  const standaloneProducts = items.filter((item) => {
    if (!item.productType) {
      return false;
    }

    const hasKitItems = kitItems.some((kitItem) => kitItem.parentItem === item.uid);
    const hasSubKits = subKitParents.some((subKit) => subKit.parentItem === item.uid);

    return !hasKitItems && !hasSubKits;
  });

  const hierarchy = productKits.map((kit) => ({
    ...kit,
    kitItems: kitItems.filter((item) => item.parentItem === kit.uid),
    subKits: subKitParents
      .filter((item) => item.parentItem === kit.uid)
      .map((subKit) => ({
        ...subKit,
        items: subKitItems.filter((item) => item.parentSubKit === subKit.uid),
      })),
  }));

  return {
    productKits: hierarchy,
    standaloneProducts,
  };
};
